import styled from 'styled-components/macro';

export const ActionBarContainer = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${({ theme }) => theme.color.gray[200]};
  background: ${({ theme }) => theme.color.white};
  flex-shrink: 0;
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.color.red[600]};
  color: ${({ theme }) => theme.color.white};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    background-color: ${({ theme }) => theme.color.gray[200]};
    color: ${({ theme }) => theme.color.gray[300]};
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const ReasonSelectorWrapper = styled.div`
  margin-bottom: 12px;
`;

export const SubmitVerificationButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.color.green[700]};
  color: ${({ theme }) => theme.color.white};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    background-color: ${({ theme }) => theme.color.gray[200]};
    color: ${({ theme }) => theme.color.gray[300]};
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.color.green[600]};
  }
`;
